import { defineMessages, injectIntl } from "react-intl";
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { far } from "@fortawesome/pro-regular-svg-icons";

// hooks
import useLocalizedLink from "../hooks/useLocalizedLink";

// Sentences to be translated
const messages = defineMessages({
    dataPrivacy: {
        id: "Tietosuoja",
        defaultMessage: "Tietosuoja"
    },
    dataPrivacyTitle: {
        id: "Ropo - Tietosuojaseloste",
        defaultMessage: "Ropo - Tietosuojaseloste"
    },
    contact: {
        id: "Yhteystiedot",
        defaultMessage: "Yhteystiedot"
    },
    contactTitle: {
        id: "Ropo - Yhteystiedot",
        defaultMessage: "Ropo - Yhteystiedot"
    },
    faq: {
        id: "UKK",
        defaultMessage: "UKK"
    }
});

export { messages };

const Footer = (props) => {
    const lng = props.intl.formatMessage;
    const { getLocalizedLink } = useLocalizedLink();
    const privacyLink = getLocalizedLink('LINK_PRIVACY');
    const contactLink = getLocalizedLink('LINK_CONTACT');
    const faqLink = getLocalizedLink('LINK_FAQ');

    return (
        <div className={`footer ${props.class ?? ""}`}>
            <nav>
                <ul className="p-0">
                    {privacyLink ? (
                        <li>
                            <a title={lng(messages.dataPrivacyTitle)} rel="noopener noreferrer"
                                href={privacyLink} target="_blank"
                                className="dataPrivacy-link" aria-label={lng(messages.dataPrivacy)}>
                                <FontAwesomeIcon icon={far.faShieldCheck} aria-hidden="true" /> {lng(messages.dataPrivacy)}
                            </a>
                        </li>
                    ) : <></>}
                    {contactLink ? (
                        <li>
                            <a title={lng(messages.contactTitle)} rel="noopener noreferrer"
                                href={contactLink} target="_blank"
                                className="contact-link" aria-label={lng(messages.contact)}>
                                <FontAwesomeIcon icon={far.faHeadset} aria-hidden="true" /> {lng(messages.contact)}
                            </a>
                        </li>
                    ) : <></>}
                    {faqLink ? (
                        <li>
                            <a title={lng(messages.faq)} rel="noopener noreferrer" href={faqLink}
                                target="_blank"
                                className="contactFaq-link" aria-label={lng(messages.faq)}>
                                <FontAwesomeIcon icon={far.faCommentsQuestionCheck} aria-hidden="true" /> {lng(messages.faq)}
                            </a>
                        </li>
                    ) : <></>}
                </ul>
            </nav>
        </div>
    );
};

Footer.propTypes = {
    'intl': PropTypes.object.isRequired,
    'class': PropTypes.string
};

export default injectIntl(Footer);